/* eslint-disable @typescript-eslint/camelcase */
const authScope = process.env.REACT_APP_AUTH_SCOPE;
const authConfig = {
  authority: process.env.REACT_APP_AUTH_AUTHORITY,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
  scope: `openid ${authScope} atg_user`,
};

export default authConfig;
